/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPBUSINESSRELATIONTYPE } from './IAPBUSINESSRELATIONTYPE';
import {
    IAPBUSINESSRELATIONTYPEFromJSON,
    IAPBUSINESSRELATIONTYPEFromJSONTyped,
    IAPBUSINESSRELATIONTYPEToJSON,
} from './IAPBUSINESSRELATIONTYPE';

/**
 * 
 * @export
 * @interface RelatedPartiesCountsViewModel
 */
export interface RelatedPartiesCountsViewModel {
    /**
     * 
     * @type {number}
     * @memberof RelatedPartiesCountsViewModel
     */
    businessRelationId?: number;
    /**
     * 
     * @type {IAPBUSINESSRELATIONTYPE}
     * @memberof RelatedPartiesCountsViewModel
     */
    businessRelationType?: IAPBUSINESSRELATIONTYPE;
    /**
     * 
     * @type {string}
     * @memberof RelatedPartiesCountsViewModel
     */
    businessRelation?: string;
    /**
     * 
     * @type {number}
     * @memberof RelatedPartiesCountsViewModel
     */
    numberOfRelations?: number;
}

/**
 * Check if a given object implements the RelatedPartiesCountsViewModel interface.
 */
export function instanceOfRelatedPartiesCountsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RelatedPartiesCountsViewModelFromJSON(json: any): RelatedPartiesCountsViewModel {
    return RelatedPartiesCountsViewModelFromJSONTyped(json, false);
}

export function RelatedPartiesCountsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelatedPartiesCountsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'businessRelationId': !exists(json, 'BusinessRelationId') ? undefined : json['BusinessRelationId'],
        'businessRelationType': !exists(json, 'BusinessRelationType') ? undefined : IAPBUSINESSRELATIONTYPEFromJSON(json['BusinessRelationType']),
        'businessRelation': !exists(json, 'BusinessRelation') ? undefined : json['BusinessRelation'],
        'numberOfRelations': !exists(json, 'NumberOfRelations') ? undefined : json['NumberOfRelations'],
    };
}

export function RelatedPartiesCountsViewModelToJSON(value?: RelatedPartiesCountsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BusinessRelationId': value.businessRelationId,
        'BusinessRelationType': IAPBUSINESSRELATIONTYPEToJSON(value.businessRelationType),
        'BusinessRelation': value.businessRelation,
        'NumberOfRelations': value.numberOfRelations,
    };
}

